module.exports = __webpack_public_path__ + "img/sheila.6ecb02e.jpg";